import { z } from 'zod'
import { baseSchema } from './base'

export const tableSchema = baseSchema
  .extend({
    type: z.literal('table'),
    rowKey: z.string().optional().describe('表格行 key 的取值，唯一标识'),
    columns: z
      .object({
        title: z.string(),
        dataIndex: z.string().optional().describe('数据源的字段名，支持点语法'),
        width: z.union([z.number(), z.string()]).optional(),
        align: z.enum(['left', 'right', 'center']).optional(),
        tpl: z.string().optional().describe('模板字符串。支持模板字符串，可以在此处做数据映射。(暂时不支持)'),
      })
      .array()
      .optional()
      .describe('表格列配置'),
    footer: z.any().array().optional().describe('表格底部'),
    api: z.string().optional().describe('数据查询地址，只支持 GET 请求，优先级高于 data'),
    data: z.union([z.any().array(), z.string()]).optional().describe('表格数据源，可以是数组或者变量。'),
    bordered: z.boolean().optional(),
    size: z.enum(['small', 'middle', 'large']).default('middle'),
    tableLayout: z
      .enum(['fixed', 'auto'])
      .optional()
      .describe('表格元素的 table-layout 属性，设为 fixed 表示内容不会影响列的布局'),
    pagination: z
      .union([
        z.literal(false),
        z.object({
          current: z.number().optional(),
          pageSize: z.number().optional(),
          total: z.number().optional(),
        }),
      ])
      .default(false)
      .describe('分页配置'),
  })
  .describe('表格组件，如果需要发起请求，建议使用 query-list。')

export type TableSchema = z.infer<typeof tableSchema>
